import { render } from "./secure-manage.vue?vue&type=template&id=edc9232e&scoped=true"
import script from "./secure-manage.vue?vue&type=script&lang=js"
export * from "./secure-manage.vue?vue&type=script&lang=js"

import "./secure-manage.vue?vue&type=style&index=0&id=edc9232e&lang=css"
import "./secure-manage.vue?vue&type=style&index=1&id=edc9232e&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edc9232e"]])

export default __exports__